<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Wybór szablonu
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="labelTemplateId"
                                :items="availableLabelTemplates"
                                label="Szablon"
                                item-text="name"
                                item-value="id"
                                no-data-text="Nie znaleziono szablonów"
                                outlined
                                dense
                                :error-messages="labelTemplateErrors"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="wybierz"
                    @click="onSave"
                >
                    Wybierz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'ImportShippingLabel',
    props: {
        isOpen: {
            type: Boolean
        },
        templateTypeIds: {
            type: Array,
            default: () => []
        },
        customerId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            labelTemplateId: null,
        }
    },
    validations() {
        return {
            labelTemplateId: {
                required
            },
        }
    },
    computed: {
        availableLabelTemplates() {
            return this.$store.state.shipments.shipmentsLabels.shipmentsLabels.shippingLabelTemplates
        },
        labelTemplateErrors() {
            const errors = []

            if (!this.$v.labelTemplateId.$dirty) return errors
            !this.$v.labelTemplateId.required && errors.push('Proszę wybrać szablon.')

            return errors
        },
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.getShippingLabelTemplates()
            }
        },
    },
    methods: {
        getShippingLabelTemplates() {
            const query = this.templateTypeIds ? `?client_id=${this.customerId}&type_ids=${this.templateTypeIds.join(',')}` : ''

            this.$store.dispatch('shipments/shipmentsLabels/getShippingLabelTemplates', {
                query
            })
                .then(() => {
                    this.labelTemplateId ? this.labelTemplateId : this.setDefaultTemplate()

                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        setDefaultTemplate() {
            this.labelTemplateId = this.availableLabelTemplates ? this.availableLabelTemplates[0].id : null
        },
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            const index = this.availableLabelTemplates.findIndex(item => item.id === this.labelTemplateId)
            const template = this.availableLabelTemplates[index]

            this.$emit('on-submit', template)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.labelTemplateId = null
            }, 500)
            this.$v.$reset()

            this.$emit('on-close')
        },
    }
}
</script>
